module.exports = __webpack_public_path__ + "img/download-small-icon.415a724d.svg";